import { memo } from 'react';

import CoverageSection from '../../../../GeneralComponents/GlobalCoverage';
import withComponentName from '../../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';

export const DueDiligenceSection = () => (
  <section className={Styles['due-diligence-section']}>
    <div className={Styles['due-diligence-title']}>
      <h1 className={`${Styles.title} text-uppercase`}>
        One Platform - All Data Types and Sources You Need
      </h1>
      <p className={Styles.institutions}>
        All financial, business, economic, and political content at your fingertips
      </p>
    </div>
    <CoverageSection
      itemsColorType="transparent"
    />
  </section>
);

export default withComponentName(memo(DueDiligenceSection));
